export type FormPublicStartUrlLocation = Pick<Location, "origin" | "pathname" | "search">;

export function buildFormPublicStartUrl(
    ingestionPointId: number,
    location: FormPublicStartUrlLocation = window.location,
): string {
    const { origin, pathname, search } = location;
    return `${origin}${pathname}${search}#!/form-submission/new?pointId=${ingestionPointId}`;
}

export function buildFormQrDownloadFileName(formName: string | undefined, ingestionPointId: number): string {
    const safeName = (formName ?? "form")
        .trim()
        .replace(/[^\w\-]+/g, "-")
        .replace(/-+/g, "-")
        .replace(/^-|-$/g, "")
        .slice(0, 40);
    const suffix = safeName.length ? `${safeName}-` : "";
    return `${suffix}form-${ingestionPointId}-qr.png`;
}
